<!-- フォーム見出しコンポーネント -->
<template>
    <dt :class="klass">
        <slot></slot>
        <em v-if="isRequired && !isSignup">必須</em>
    </dt>
</template>

<script>
export default {
    name: 'UserInfoFieldTitle',
    props: {
        isRequired: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: false
        },
        formName: {
            type: String,
            default: ''
        },
    },
    computed: {
        klass: function(){
            // 必須 ∧ valid のとき valid アイコンを表示する
            const isValid = this.isRequired && this.valid;

            return { valid: isValid };
        },
        isSignup: function(){
            return this.formName === 'signup';
        }
    }
}
</script>
